import { useCallback, useContext, useEffect, useState } from 'react';
import MainContext from '../../context/MainContext';
import useIsMobile from '../../hooks/useIsMobile';
import Loader from '../Loader';
import { useForm } from 'react-hook-form';
import useOffer from '../../api/hooks/useOffers';
import { apiURL } from '../../consts/URLs';



const ContoVendita = (props: any) => {

  const { user, userTreated, token } = useContext(MainContext);
  const [startDate, setStartDate] = useState<Date | null>(new Date());
  const [endDate, setEndDate] = useState<Date | null>(new Date());
  const exportContoVenditaForm=useForm();


  const handleSubmit=()=>{
    let startMonth=1;
    let endMonth=1;
    if(startDate!==null){
        startMonth=startDate.getMonth()+1;
    }
    if(endDate!==null){
        endMonth=endDate.getMonth()+1;
    }

    const endpoint = `${apiURL}/operations/report_conto_vendita?from_date=${startDate?.getFullYear()}-${startMonth}-${startDate?.getDate()}&to_date=${endDate?.getFullYear()}-${endMonth}-${endDate?.getDate()}`;
    alert("Per consentire il download del file .csv, consentire alla pagina seguente di aprire popup dalle impostazioni del browser!");
    window.open(endpoint); 
  };



    return (
        <div
            className='users-table shadow'
        >
            <div className='user-table-header-title-box' style={{ paddingLeft: "20px", paddingTop: "30px" }}>
                <p className='user-table-header-title'>Gestione Conto Vendita</p>
                <p className='user-table-header-description'>Download csv cumulativo degli ordini relartivi a prodotti in conto vendita che sono stati venduti nel periodo selzionato</p>
            </div>
            <br/>
            <br/>
            <div >
                <form onSubmit={exportContoVenditaForm.handleSubmit(handleSubmit)} style={{ paddingLeft: "20px" }}>

                    <label htmlFor={'startDate'}>Data di inzio:</label>
                    <input id="startDate" type="date" defaultValue={startDate?.toDateString()} onChange={(date) => setStartDate(date.target.valueAsDate)} />
                    <br/>
                    <label htmlFor={'endDate'}>Data di fine:</label>
                    <input id="endDate" type="date" defaultValue={endDate?.toDateString()} onChange={(date) => setEndDate(date.target.valueAsDate)} />

                    <br/>
                    <br/>
                    <button
                        className='modal-button'
                        style={{
                            background: 'green',
                            color: 'white',
                            margin: 0,
                            width: '100px'
                        }}
                        type={"submit"}
                    >
                        <p className='add-buttonText'>Scarica CSV</p>
                    </button>
                </form>
            </div>

        </div>
    );
};


export default ContoVendita;